<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-8">
        <span class="display-4 col-12">{{ $t("COMMON.DETAILS") }}</span>
      </div>
    </div>

    <stock-movement-view-details-product-list
      v-if="stockMovement.id"
      :stockMovement="stockMovement"
      @stockMovementItemsUpdated="stockMovementItemsUpdated"
      @stockMovementItemsAdded="stockMovementItemsAdded"
      :key="renderKey"
    />
  </div>
</template>

<script>
import { Button, Tooltip } from "element-ui";
import StockMovementViewDetailsProductList from "./StockMovementViewDetailsProductList.vue";

export default {
  name: "stock-movement-view-details",

  components: {
    StockMovementViewDetailsProductList,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
  },

  mixins: [],

  props: ["stockMovement"],

  data() {
    return {
      renderKey: 0,
    };
  },

  computed: {},

  methods: {
    stockMovementItemsUpdated(stockMovementItem) {
      this.$emit("stockMovementItemsUpdated", stockMovementItem);
    },
    stockMovementItemsAdded(stockMovementItem) {
      this.$emit("stockMovementItemsAdded", stockMovementItem);
    },
  },

  mounted() {},

  watch: {},
};
</script>
